



































import { ClientRoutes } from "@/data/enums/router";
import { Vue, Component } from "vue-property-decorator";
@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
})
export default class ContentPane extends Vue {
  public readonly clientLoginRoute = { name: ClientRoutes.LOGIN };
  public get component() {
    const matchedRoute = this.$route.matched[this.$route.matched.length - 1];
    const componentName = "default";
    return matchedRoute.components[componentName];
  }
}
